import styles from './LinkManagement.module.css';
import referWithText from 'assets/refer-with-text.svg';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentAccount, selectUser } from 'store/userSlice';
import GlobirdSelector from 'components/Shared/GlobirdSelector';
import menuOptions from '../MenuOptions';
import { useNavigate } from 'react-router-dom';
import ReferralLinks from '../ReferralLinks';
import NewReferral from '../NewLink';
import { lookupReferralLink } from 'services/RequestDataService';

const LinkManagement = () => {
	const navigate = useNavigate();
	const currentAccount = useSelector(selectCurrentAccount);
	const currentUser = useSelector(selectUser);
	const [showPreviousLinks, setShowPreviousLinks] = useState<boolean>(false);
	const [showReferral, setShowReferral] = useState<boolean>(false);
	const [showReferralError, setShowReferralError] = useState<boolean>(false);
	const [key, setKey] = useState<number>(0);

	useEffect(() => {
		const populateReferral = async () => {
			if (!currentAccount || !currentUser) {
				return;
			}

			const result = await lookupReferralLink(currentAccount.accountId, currentUser.emailAddress);
			
			setShowPreviousLinks(true);

			if (!result?.success || !result.data) {
				setShowReferral(false);
				setShowReferralError(true);
				return;
			}

			setShowReferral(true);
			setShowReferralError(false);
		};
		
		setShowReferral(false);
		setShowReferralError(false);
		setShowPreviousLinks(false);

		populateReferral();
	}, [currentAccount]);

	const onLinkGenerated = () => {
		setKey(key + 1);
	};

	return (
		<div>
			<div
				className="form-container"
				style={{ maxWidth: '1000px', minHeight: 'auto', paddingBottom: '10px' }}
			>
				<div className="globird-menu-option">
					<p className="globird-menu-label">Show me:</p>
					<GlobirdSelector
						id="linkManagementMenuSelector"
						options={menuOptions}
						defaultOption={menuOptions[0]}
						onSelected={(targetMenu) => {
							navigate(`/${targetMenu.value}`);
						}}
					/>
				</div>
				{showReferral && !showReferralError ? (
					<div className="field-container" style={{ width: '90%' }}>
						<h4 className={styles['page-heading']}>
							View your referral link and share with your friends
						</h4>
						<h3 className={styles['referral-heading']}>New Referral Link</h3>
						<NewReferral onLinkGenerated={onLinkGenerated} />
					</div>
				) : null}
				{showReferralError ? (
					<div className="field-container" style={{ width: '90%' }}>
						<h2 style={{ textAlign: 'center' }}>
							Unable to get referral link, please refer to the terms and conditions for
							eligibility
						</h2>
					</div>
				) : null}
			</div>
			{showPreviousLinks ? <ReferralLinks key={key} /> : null}
			<div className={styles['terms-and-conditions-container']}>
				<div className={styles['conditions-container']}>
					<h3>Referral Conditions:</h3>
					<ol>
						<li>Residential accounts only (not available to Business)</li>
						<li>No current outstanding account with GloBird</li>
						<li>Referral is not available on some plans</li>
					</ol>
					<p>
						{' '}
						The full terms & conditions of this programme can be found &nbsp;
						<a
							href="https://www.globirdenergy.com.au/legal/referral-terms-conditions/"
							rel="noopener noreferrer"
							target="_blank"
						>
							here
						</a>
					</p>
				</div>
				<img className={styles['refer-a-friend-img']} src={referWithText} alt="refer a friend" />
			</div>
		</div>
	);
};

export default LinkManagement;
